import React, { useContext } from 'react';
import './ReportIssue.css';
import IssueCoordinates from './coordinates/IssueCoordinates';
import { AppInfoContext } from '../../../App';

const ReportIssue = () => {
  const { appInformation, setAppInformation } = useContext(AppInfoContext);

  const increaseStep = () => {
    setAppInformation((prevValue) => {
      const { citizenReport } = prevValue;
      return {
        ...prevValue,
        citizenReport: {
          ...citizenReport,
          currentStep: citizenReport.currentStep + 1,
        },
      };
    });
  };

  const renderStep = () => {
    switch (appInformation.citizenReport.currentStep) {
      case 0:
        return (
          <div className="first-step">
            <h4 className="instructions">
              Da započnete sa prijavom kvara kliknite na dugme ispod.
            </h4>
            <button className="instructions-button" onClick={increaseStep}>
              Prijavi kvar
            </button>
          </div>
        );
      case 1:
        return (
          <div className="second-step">
            {!appInformation.citizenReport.issueCoordinates.x && (
              <h4 className="instructions">
                Klikom pokazivača na mapi označite lokaciju kvara kako biste
                nastavili sa prijavom.
              </h4>
            )}
            {appInformation.citizenReport.issueCoordinates.x && (
              <>
                <h4 className="instructions">
                  Lokacija označena. Ukoliko želite promijeniti lokaciju
                  kliknite na dugme nazad.
                </h4>
              </>
            )}
            <IssueCoordinates
              updateIssueCoordinates={(newX, newY) => {
                setAppInformation((prevValue) => {
                  const { citizenReport } = prevValue;
                  return {
                    ...prevValue,
                    citizenReport: {
                      ...citizenReport,
                      issueCoordinates: { x: newX, y: newY },
                    },
                  };
                });
              }}
            />
          </div>
        );
      case 2:
        return (
          <div>
            <h4 className="instructions">
              Popunite preostala polja kako biste završili sa prijavom kvara.
            </h4>
          </div>
        );
      default:
        return <div>Unknown step</div>;
    }
  };
  return <div id="report-issue">{renderStep()}</div>;
};

export default ReportIssue;
